import { render, staticRenderFns } from "./EditMonitor.vue?vue&type=template&id=24ef3afc&scoped=true&"
import script from "./EditMonitor.vue?vue&type=script&lang=js&"
export * from "./EditMonitor.vue?vue&type=script&lang=js&"
import style0 from "./EditMonitor.vue?vue&type=style&index=0&id=24ef3afc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef3afc",
  null
  
)

export default component.exports